// src/app/uiSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { sanitizeCompanyLogoUrl } from '../functions/companyLogoUrl';

const persistedUser = JSON.parse(sessionStorage.getItem('userData') || 'null');
const persistedBackButtonUrl = sessionStorage.getItem('backButtonUrl');
const initialState = {
  companyLogoUrl: sanitizeCompanyLogoUrl(persistedUser?.companyLogoUrl ?? null),
  backButtonUrl: persistedBackButtonUrl || null,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setCompanyLogoUrl(state, action) {
      state.companyLogoUrl = sanitizeCompanyLogoUrl(action.payload ?? null);
    },
    setBackButtonUrl(state, action) {
      state.backButtonUrl = action.payload;
      // Persist to sessionStorage so it survives navigation
      if (action.payload) {
        sessionStorage.setItem('backButtonUrl', action.payload);
      } else {
        sessionStorage.removeItem('backButtonUrl');
      }
    },
  },
});

export const { setCompanyLogoUrl, setBackButtonUrl } = uiSlice.actions;
export default uiSlice.reducer;
